module.exports = __webpack_public_path__ + "img/yue1.534155f6.svg";